var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 46V42.55C33.7812 42.55 42.55 33.7812 42.55 23C42.55 12.2188 33.7812 3.45 23 3.45V0C35.6859 0 46 10.3141 46 23C46 35.6859 35.6859 46 23 46Z",
    fill: "#BDCCD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 31.625V28.175C35.65 28.175 42.55 24.7609 42.55 23H46C46 28.6422 34.4281 31.625 23 31.625Z",
    fill: "#006BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 46C10.3141 46 0 35.6859 0 23C0 10.3141 10.3141 0 23 0V3.45C12.2188 3.45 3.45 12.2188 3.45 23C3.45 33.7812 12.2188 42.55 23 42.55V46Z",
    fill: "#BDCCD4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45 23H0C0 17.3578 11.5719 14.375 23 14.375V17.825C10.35 17.825 3.45 21.2391 3.45 23Z",
    fill: "#006BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.825 23H14.375C14.375 11.5719 17.3578 0 23 0V3.45C21.2391 3.45 17.825 10.35 17.825 23Z",
    fill: "#0AE8F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23 46V42.55C24.7609 42.55 28.175 35.65 28.175 23H31.625C31.625 34.4281 28.6422 46 23 46Z",
    fill: "#0AE8F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.625 23H28.175C28.175 10.35 24.7609 3.45 23 3.45V0C28.6422 0 31.625 11.5719 31.625 23Z",
    fill: "#0AE8F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23 46C17.3578 46 14.375 34.4281 14.375 23H17.825C17.825 35.65 21.2391 42.55 23 42.55V46Z",
    fill: "#0AE8F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23 31.625C11.5719 31.625 0 28.6422 0 23H3.45C3.45 24.7609 10.35 28.175 23 28.175V31.625Z",
    fill: "#006BFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46 23H42.55C42.55 21.2391 35.65 17.825 23 17.825V14.375C34.4281 14.375 46 17.3219 46 23Z",
    fill: "#006BFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9999 3.45C23.9702 3.45 24.7249 2.69531 24.7249 1.725C24.7249 0.754688 23.9343 0 22.9999 0C22.0655 0 21.2749 0.754688 21.2749 1.725C21.2749 2.69531 22.0296 3.45 22.9999 3.45Z",
    fill: "#0AE8F0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9999 17.825C23.9702 17.825 24.7249 17.0703 24.7249 16.1C24.7249 15.1297 23.9343 14.375 22.9999 14.375C22.0655 14.375 21.2749 15.1297 21.2749 16.1C21.2749 17.0703 22.0296 17.825 22.9999 17.825Z",
    fill: "#006BFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9999 31.6251C23.9702 31.6251 24.7249 30.8704 24.7249 29.9001C24.7249 28.9298 23.9702 28.1751 22.9999 28.1751C22.0655 28.1751 21.2749 28.9298 21.2749 29.9001C21.2749 30.8345 22.0296 31.6251 22.9999 31.6251Z",
    fill: "#006BFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9999 46.0001C23.9702 46.0001 24.7249 45.2454 24.7249 44.2751C24.7249 43.3048 23.9702 42.5501 22.9999 42.5501C22.0655 42.5501 21.2749 43.3048 21.2749 44.2751C21.2749 45.2094 22.0296 46.0001 22.9999 46.0001Z",
    fill: "#0AE8F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.725 24.725C2.69531 24.725 3.45 23.9703 3.45 23C3.45 22.0656 2.69531 21.275 1.725 21.275C0.754688 21.275 0 22.0297 0 23C0 23.9344 0.754688 24.725 1.725 24.725Z",
    fill: "#006BFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1 24.725C17.0344 24.725 17.825 23.9703 17.825 23C17.825 22.0656 17.0703 21.275 16.1 21.275C15.1297 21.275 14.375 22.0297 14.375 23C14.375 23.9344 15.1297 24.725 16.1 24.725Z",
    fill: "#0AE8F0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9 24.725C30.8344 24.725 31.625 23.9703 31.625 23C31.625 22.0656 30.8704 21.275 29.9 21.275C28.9297 21.275 28.175 22.0297 28.175 23C28.175 23.9344 28.9297 24.725 29.9 24.725Z",
    fill: "#0AE8F0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M44.275 24.725C45.2094 24.725 46 23.9703 46 23C46 22.0656 45.2454 21.275 44.275 21.275C43.3047 21.275 42.55 22.0297 42.55 23C42.55 23.9344 43.3047 24.725 44.275 24.725Z",
    fill: "#006BFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.a0fd479c7395540e5510084aa97655bd.svg";
export { ForwardRef as ReactComponent };